import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  Offer,
  OfferPaginationOptions,
  OfferQueryParams,
  OfferSource,
} from '@rd/types';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  getOfferHubGetOfferDetailsLoading,
  getOfferHubGetOfferError,
  getOfferHubGetOfferLoading,
  getOfferList,
  getOfferListCount,
  getOfferListPageNumber,
  getOfferListTotalPages,
  getOfferRenderState,
  getOffersBySource,
  LoadBnzHomepageOffers,
  LoadMoreOffers,
  LoadOffers,
  LoadPaginatedOffers,
} from '../store';

@Injectable({
  providedIn: 'root',
})
export class OfferFacade {
  constructor(private store: Store) {}

  offerLoading$ = this.store.select(getOfferHubGetOfferLoading);
  offerDetailLoading$ = this.store.select(getOfferHubGetOfferDetailsLoading);
  offerError$ = this.store.select(getOfferHubGetOfferError);
  offerRenderedState$ = this.store.select(getOfferRenderState);
  offerListCount$ = this.store.select(getOfferListCount);
  offerListPageNumber$ = this.store
    .select(getOfferListPageNumber)
    .pipe(map((pageNumber) => pageNumber || 1));
  offerListTotalPages$ = this.store.select(getOfferListTotalPages);
  offerListItems$ = this.store.select(getOfferList);

  loadOffers(params: {
    queryParams: OfferQueryParams;
    shouldShowLoadingState?: boolean;
  }): void {
    this.store.dispatch(new LoadOffers(params));
  }

  loadPaginatedOffers(params: {
    queryParams: OfferQueryParams;
    paginationOptions: OfferPaginationOptions;
  }): void {
    this.store.dispatch(new LoadPaginatedOffers(params));
  }

  loadMoreOffers(params: {
    queryParams: OfferQueryParams;
    shouldShowLoadingState?: boolean;
  }): void {
    this.store.dispatch(new LoadMoreOffers(params));
  }

  loadBnzHomepageOffers(): void {
    this.store.dispatch(new LoadBnzHomepageOffers());
  }

  getOffersBySource$(source: OfferSource): Observable<Offer[]> {
    return this.store.select(getOffersBySource(source));
  }
}
